import React  from "react";
import { connect } from "react-redux";
import SummaryCard from "components/widget/SummaryCard";
import TrainingOverviewTab from "./components/TrainingOverviewTab";
import { LucideAward, LucideBookOpen, LucideClock, LucideLineChart } from "lucide-react";



const TrainingOverviews = () => {
	return (

    <>
	    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <SummaryCard
          title={"Total Enrollments"}
          icon={<LucideBookOpen size={16}/>}
          displayCount={22}
          description={"Across all courses"}
          textColor="text-slate-900 dark:text-slate-100"
        />	

        <SummaryCard
          title={"Completed"}
          icon={<LucideAward size={16}/>}
          displayCount={72}
          description={"Certificates issued"}
          textColor="text-green-600 dark:text-green-500"
        />

        <SummaryCard
          title={"In Progress"}
          icon={<LucideClock size={16}/>}
          displayCount={82}
          description={"Active learners"}
          textColor="text-blue-600 dark:text-blue-500"
        />		
        <SummaryCard
          title={"Avg. Completion"}
          icon={<LucideLineChart size={16}/>}
          displayCount={"92%"}
          description={"Completion rate"}
          textColor="text-slate-900 dark:text-slate-100"
        />	
      </div>
      <div className="w-full mt-5">
          <TrainingOverviewTab />
      </div>
    </>
	

      
    );
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(TrainingOverviews);